const mobilePass = {
  addMobileCredentials: 'Ajouter des identifiants mobiles',
  count: '<1>{{count}}</1> identifiant(s) mobile(s) disponible(s)',
  modalTitle: 'Achat de KRYPTO Mobile-PASS',
  accountName: 'Nom du compte : ',
  purchaseHistory: 'Historique des achats : ',
  currentlyAvailable: 'Actuellement disponibles : ',
  warning:
    "Vous êtes sur le point d'acheter {{ number }} KRYPTO Mobile-PASS pour un total de {{ price }}. Êtes-vous sûr ?",
  outOfMobilePasses:
    "Vous n'avez plus d'identifiants mobiles, veuillez contacter votre instsallateur pour en ajouter à votre compte.",
  count_one: 'Vous avez <1>{{ count }}</1> identifiant mobile disponible.',
  count_other: 'Vous avez <1>{{ count }}</1> identifiants mobile disponibles.',
};

export default mobilePass;
